import { animate, group, query, style, transition, trigger } from '@angular/animations';

export const RouteSlideAnimation = trigger('routeAnimations', [
  // IDEA: technically, using a 1x1 grid to stack components should be easier to read
  transition('left => right', [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        display: 'block'
      })
    ]),
    query(':enter', [
      style({
        display: 'block', // so that transform works on app-* components
        position: 'absolute', // so that they the leaving and entering components "stack"
        top: 0, // stacking on "top"
        left: 0, // stacking left aligned
        width: '100%' // on full width
      })
    ]),
    query(':enter', [
      // entering component starts wooshing in from the right edge of the screen
      style({ transform: 'translateX(100%)' })
    ]),
    group([
      // simultaniously animate in and out
      query(':leave', [
        // woosh out to the left of the screen
        animate('300ms ease-in-out', style({ transform: 'translateX(-100%)' }))
      ]),
      query(':enter', [
        // woosh in
        animate('300ms ease-in-out', style({ transform: 'translateX(0%)' }))
      ])
    ])
  ]),
  transition('right => left', [
    style({ position: 'relative' }),
    query(':enter, :leave', [
      style({
        display: 'block'
      })
    ]),
    query(':enter', [
      style({
        display: 'block', // so that transform works on app-* components
        position: 'absolute', // so that they the leaving and entering components "stack"
        top: 0, // stacking on "top"
        left: 0, // stacking left aligned
        width: '100%' // on full width
      })
    ]),
    query(':enter', [
      // entering component starts wooshing in from the right edge of the screen
      style({ transform: 'translateX(-100%)' })
    ]),
    group([
      // simultaniously animate in and out
      query(':leave', [
        // woosh out to the left of the screen
        animate('300ms ease-in-out', style({ transform: 'translateX(100%)' }))
      ]),
      query(':enter', [
        // woosh in
        animate('300ms ease-in-out', style({ transform: 'translateX(0%)' }))
      ])
    ])
  ])
]);
